import React from 'react';

export const PROFILE_MAX_ACTIVITY_ITEMS = 5;

export const RecentActivityContainer = ({ children }: { children: React.ReactNode }) => {
  return <div className="mb-0 flex flex-col items-center">{children}</div>;
};

export const ProfileContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <div className=" w-full bg-white">{children}</div>
    </div>
  );
};

export const ProfileWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="relative -top-14 mx-auto mt-0 flex w-full max-w-7xl flex-col lg:-top-32 lt:px-12">
      {children}
    </div>
  );
};
